import React, { useState, useEffect } from 'react';

import EmptyList from '../useful/EmptyList';
import { withAuthorization } from '../session';
import { orderByGroups } from '../TeamList/TeamsUtil'
import ClassificationTable from './ClassificationTable';

const ClassificationGroup = (props) => {

    const { teams } = props;
    const [sortedGroups, setSortedGroups] = useState([]);

    useEffect(() => {
        const sg = orderByGroups(teams);
        setSortedGroups(sg);
    }, [teams]);


    const listView = (sortedGroups && sortedGroups.length > 0) ?
        sortedGroups.map((group, i) => {
            return (
                <div key={i} className="w-100 mt-2 ">
                    <p className="small font-weight-bolder text-center text-uppercase mb-1">{group.group.title}</p>
                    <ClassificationTable teams={group.teams} />
                </div>
            )
        })
        :
        <EmptyList />

    return (
        <>
            {listView}
        </>
    )
}

const condition = authUser => {
    if (!!authUser) {
        return authUser.token.admin || authUser.token.premium;
    } else
        return false;
};
export default withAuthorization(condition)(ClassificationGroup);